import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";
import {
  ILiftOffGalaxyStandardDTO,
  ILiftOffGalaxyStandard,
} from "../model/interface/liftOffGalaxyStandard";

export const addLiftOffGalaxyStandard = (
  LiftOffGalaxyStandards: Array<ILiftOffGalaxyStandard>
) => {
  return AxiosHelper.axiosInstance().post(
    `${APIConstant.CMS_LIFTOFFGALAXYSTANDARD}`,
    { LiftOffGalaxyStandards },
    {}
  );
};

export const editLiftOffGalaxyStandard = (
  liftOffGalaxyStandardData: ILiftOffGalaxyStandardDTO
) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.CMS_LIFTOFFGALAXYSTANDARD,
    liftOffGalaxyStandardData,
    {}
  );
};

export const getLiftOffGalaxyStandard = (
  liftOffHeaderId: number,
  liftOffGalaxyId: number,
  getGroupedResult: boolean,
  pageNumber: number,
  pageSize: number
) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFGALAXYSTANDARD}`,
    {
      params: {
        liftOffHeaderId: liftOffHeaderId,
        liftOffGalaxyId: liftOffGalaxyId,
        getGroupedResult: getGroupedResult,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  );
};

export const getLiftOffGalaxyStandardInfo = (liftOffHeaderId: number) => {
  return AxiosHelper.axiosInstance().get(
    `${APIConstant.CMS_LIFTOFFGALAXYSTANDARD}/${liftOffHeaderId}`,
    {}
  );
};

export const deleteLiftOffGalaxyStandard = (
  liftOffGalaxyStandardData: ILiftOffGalaxyStandardDTO
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_LIFTOFFGALAXYSTANDARD,
    {
      data: {
        liftOffHeaderId: liftOffGalaxyStandardData.liftOffHeaderId,
        standardId: liftOffGalaxyStandardData.standardId,
        liftOffGalaxyId: liftOffGalaxyStandardData.liftOffGalaxyId,
        orderNumber: liftOffGalaxyStandardData.orderNumber,
        isActive: liftOffGalaxyStandardData.isActive,
        createdByUserId: liftOffGalaxyStandardData.createdByUserId,
        updatedByUserId: liftOffGalaxyStandardData.updatedByUserId,
      },
    }
  );
};
